import { DrillingCostBase } from './base/drilling-cost-base';

export class DrillingCost extends DrillingCostBase { }